module.exports = __webpack_public_path__ + "static/img/yichu.118749a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/yichu.png
// module id = yapf
// module chunks = 24